<wiz-hgroup width="100%" height="100%">
  <full-calendar #fullcalendar *ngIf="readyToGo" [options]="calendarOptions" style="max-width: unset !important;"></full-calendar>
</wiz-hgroup>
